module.exports = __webpack_public_path__ + "img/bookcaseIcon.c91daeb9.svg";